@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_473_843_149)
internal val Res.string.exp_content_frasi_con_soggetto_1: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_soggetto_1", "exp_content_frasi_con_soggetto_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49658, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49738, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 50970, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47898, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46154, 56),
      ))
    }

@delegate:ResourceContentHash(1_620_091_662)
internal val Res.string.exp_content_frasi_con_soggetto_2: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_soggetto_2", "exp_content_frasi_con_soggetto_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49715, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49799, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51035, 172),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 47959, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46211, 168),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_frasi_con_soggetto_3: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_soggetto_3", "exp_content_frasi_con_soggetto_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49900, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 49988, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51208, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 48144, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46380, 48),
      ))
    }

@delegate:ResourceContentHash(1_658_129_269)
internal val Res.string.exp_content_frasi_con_soggetto_4: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_soggetto_4", "exp_content_frasi_con_soggetto_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 49949, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 50041, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51261, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 48193, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46429, 104),
      ))
    }

@delegate:ResourceContentHash(67_305_837)
internal val Res.string.exp_content_frasi_con_soggetto_5: StringResource by lazy {
      StringResource("string:exp_content_frasi_con_soggetto_5", "exp_content_frasi_con_soggetto_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50054, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 50154, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51370, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 48298, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46534, 88),
      ))
    }

@delegate:ResourceContentHash(-343_636_679)
internal val Res.string.exp_content_frequentemente_venivano_ripetuti_i_simboli_an: StringResource by
    lazy {
      StringResource("string:exp_content_frequentemente_venivano_ripetuti_i_simboli_an", "exp_content_frequentemente_venivano_ripetuti_i_simboli_an", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50147, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 50247, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51463, 181),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 48379, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46623, 157),
      ))
    }

@delegate:ResourceContentHash(-681_098_148)
internal val Res.string.exp_content_genitivo_indiretto_esempio_1: StringResource by lazy {
      StringResource("string:exp_content_genitivo_indiretto_esempio_1", "exp_content_genitivo_indiretto_esempio_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50313, 176),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 50425, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51645, 176),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 48549, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46781, 160),
      ))
    }

@delegate:ResourceContentHash(-161_664_131)
internal val Res.string.exp_content_genitivo_indiretto_esempio_2: StringResource by lazy {
      StringResource("string:exp_content_genitivo_indiretto_esempio_2", "exp_content_genitivo_indiretto_esempio_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50490, 144),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 50594, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51822, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 48722, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46942, 128),
      ))
    }

@delegate:ResourceContentHash(-491_261_690)
internal val Res.string.exp_content_gli_scribi_si_sentivano_molto_liberi_di_piega: StringResource by
    lazy {
      StringResource("string:exp_content_gli_scribi_si_sentivano_molto_liberi_di_piega", "exp_content_gli_scribi_si_sentivano_molto_liberi_di_piega", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50635, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 50739, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 51967, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 48867, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47071, 137),
      ))
    }

@delegate:ResourceContentHash(-2_064_722_532)
internal val Res.string.exp_content_hiero_verbs_2_nilo: StringResource by lazy {
      StringResource("string:exp_content_hiero_verbs_2_nilo", "exp_content_hiero_verbs_2_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50793, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 50901, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 52129, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49029, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47209, 134),
      ))
    }

@delegate:ResourceContentHash(1_780_023_635)
internal val Res.string.exp_content_hiero_verbs_3_alyn: StringResource by lazy {
      StringResource("string:exp_content_hiero_verbs_3_alyn", "exp_content_hiero_verbs_3_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50916, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51048, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 52276, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49160, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47344, 66),
      ))
    }

@delegate:ResourceContentHash(1_655_115_359)
internal val Res.string.exp_content_hiero_verbs_3_zeta: StringResource by lazy {
      StringResource("string:exp_content_hiero_verbs_3_zeta", "exp_content_hiero_verbs_3_zeta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 50987, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51127, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 52359, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49231, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47411, 118),
      ))
    }

@delegate:ResourceContentHash(2_000_048_643)
internal val Res.string.exp_content_i_cartigli_erano_riservati_alle_divinita_inclusi_i_faraoni:
    StringResource by lazy {
      StringResource("string:exp_content_i_cartigli_erano_riservati_alle_divinita_inclusi_i_faraoni", "exp_content_i_cartigli_erano_riservati_alle_divinita_inclusi_i_faraoni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 51126, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51266, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 52498, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49358, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47530, 126),
      ))
    }

@delegate:ResourceContentHash(-65_725_317)
internal val Res.string.exp_content_i_complementi_fonetici_sono_segni_monolitteri: StringResource by
    lazy {
      StringResource("string:exp_content_i_complementi_fonetici_sono_segni_monolitteri", "exp_content_i_complementi_fonetici_sono_segni_monolitteri", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 51261, 305),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51397, 273),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 52629, 289),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49485, 253),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47657, 241),
      ))
    }

@delegate:ResourceContentHash(362_435_542)
internal val Res.string.exp_content_i_disegni_geroglifici_sono_calibrati_ovvero_n: StringResource by
    lazy {
      StringResource("string:exp_content_i_disegni_geroglifici_sono_calibrati_ovvero_n", "exp_content_i_disegni_geroglifici_sono_calibrati_ovvero_n", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 51567, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51671, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 52919, 209),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49739, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47899, 177),
      ))
    }

@delegate:ResourceContentHash(401_929_808)
internal val Res.string.exp_content_i_due_fratelli_snuy: StringResource by lazy {
      StringResource("string:exp_content_i_due_fratelli_snuy", "exp_content_i_due_fratelli_snuy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 51761, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51857, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 53129, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49909, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48077, 75),
      ))
    }

@delegate:ResourceContentHash(-51_514_529)
internal val Res.string.exp_content_i_fonogrammi_rappresentano_suoni_n_npossono_e: StringResource by
    lazy {
      StringResource("string:exp_content_i_fonogrammi_rappresentano_suoni_n_npossono_e", "exp_content_i_fonogrammi_rappresentano_suoni_n_npossono_e", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 51841, 237),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 51933, 249),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 53209, 257),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 49981, 241),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48153, 233),
      ))
    }

@delegate:ResourceContentHash(-36_542_383)
internal val Res.string.exp_content_i_geroglifici_rappresentano_solo_consonanti_e: StringResource by
    lazy {
      StringResource("string:exp_content_i_geroglifici_rappresentano_solo_consonanti_e", "exp_content_i_geroglifici_rappresentano_solo_consonanti_e", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52079, 285),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52183, 273),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 53467, 313),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 50223, 273),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48387, 257),
      ))
    }

@delegate:ResourceContentHash(-1_898_674_150)
internal val Res.string.exp_content_i_simboli_determinativi_servono_a_chiarire_il: StringResource by
    lazy {
      StringResource("string:exp_content_i_simboli_determinativi_servono_a_chiarire_il", "exp_content_i_simboli_determinativi_servono_a_chiarire_il", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52365, 169),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52457, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 53781, 169),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 50497, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48645, 165),
      ))
    }

@delegate:ResourceContentHash(890_507_311)
internal val Res.string.exp_content_i_verbi_pi_comuni_della_lingua_egizia: StringResource by lazy {
      StringResource("string:exp_content_i_verbi_pi_comuni_della_lingua_egizia", "exp_content_i_verbi_pi_comuni_della_lingua_egizia", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52535, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52639, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 53951, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 50671, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48811, 121),
      ))
    }

@delegate:ResourceContentHash(-831_305_354)
internal val Res.string.exp_content_il_dimostrativo_pn_1: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_1", "exp_content_il_dimostrativo_pn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53313, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53369, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54693, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51389, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49513, 112),
      ))
    }

@delegate:ResourceContentHash(109_495_011)
internal val Res.string.exp_content_il_dimostrativo_pn_10: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_10", "exp_content_il_dimostrativo_pn_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52665, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52757, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54081, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 50785, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48933, 97),
      ))
    }

@delegate:ResourceContentHash(522_254_366)
internal val Res.string.exp_content_il_dimostrativo_pn_11: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_11", "exp_content_il_dimostrativo_pn_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52759, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52847, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54183, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 50875, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49031, 113),
      ))
    }

@delegate:ResourceContentHash(535_214_210)
internal val Res.string.exp_content_il_dimostrativo_pn_12: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_12", "exp_content_il_dimostrativo_pn_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52893, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52965, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54293, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 50985, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49145, 85),
      ))
    }

@delegate:ResourceContentHash(625_428_392)
internal val Res.string.exp_content_il_dimostrativo_pn_13: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_13", "exp_content_il_dimostrativo_pn_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 52995, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53059, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54387, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51079, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49231, 97),
      ))
    }

@delegate:ResourceContentHash(167_003_406)
internal val Res.string.exp_content_il_dimostrativo_pn_14: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_14", "exp_content_il_dimostrativo_pn_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53113, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53169, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54501, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51185, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49329, 89),
      ))
    }

@delegate:ResourceContentHash(-94_517_751)
internal val Res.string.exp_content_il_dimostrativo_pn_15: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_15", "exp_content_il_dimostrativo_pn_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53215, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53279, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54603, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51295, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49419, 93),
      ))
    }

@delegate:ResourceContentHash(1_767_286_642)
internal val Res.string.exp_content_il_dimostrativo_pn_2: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_2", "exp_content_il_dimostrativo_pn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53426, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53462, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54798, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51482, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49626, 88),
      ))
    }

@delegate:ResourceContentHash(55_440_736)
internal val Res.string.exp_content_il_dimostrativo_pn_3: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_3", "exp_content_il_dimostrativo_pn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53519, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53547, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54887, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51567, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49715, 56),
      ))
    }

@delegate:ResourceContentHash(1_493_947_229)
internal val Res.string.exp_content_il_dimostrativo_pn_4: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_4", "exp_content_il_dimostrativo_pn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53584, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53604, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 54948, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51624, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49772, 96),
      ))
    }

@delegate:ResourceContentHash(-634_607_010)
internal val Res.string.exp_content_il_dimostrativo_pn_5: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_5", "exp_content_il_dimostrativo_pn_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53693, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53713, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55057, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51725, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49869, 84),
      ))
    }

@delegate:ResourceContentHash(-26_786_136)
internal val Res.string.exp_content_il_dimostrativo_pn_6: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_6", "exp_content_il_dimostrativo_pn_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53790, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53806, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55150, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51806, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49954, 96),
      ))
    }

@delegate:ResourceContentHash(2_101_969_497)
internal val Res.string.exp_content_il_dimostrativo_pn_7: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_7", "exp_content_il_dimostrativo_pn_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 53907, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 53907, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55279, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 51911, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50051, 96),
      ))
    }

@delegate:ResourceContentHash(2_059_860_866)
internal val Res.string.exp_content_il_dimostrativo_pn_8: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_8", "exp_content_il_dimostrativo_pn_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54012, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54020, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55388, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52008, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50148, 76),
      ))
    }

@delegate:ResourceContentHash(-1_505_061_679)
internal val Res.string.exp_content_il_dimostrativo_pn_9: StringResource by lazy {
      StringResource("string:exp_content_il_dimostrativo_pn_9", "exp_content_il_dimostrativo_pn_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54093, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54109, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55473, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52089, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50225, 104),
      ))
    }

@delegate:ResourceContentHash(179_927_712)
internal val Res.string.exp_content_il_genere_pu_essere_maschile_o_femminile: StringResource by
    lazy {
      StringResource("string:exp_content_il_genere_pu_essere_maschile_o_femminile", "exp_content_il_genere_pu_essere_maschile_o_femminile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54198, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54214, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55590, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52190, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50330, 104),
      ))
    }

@delegate:ResourceContentHash(-1_576_440_931)
internal val Res.string.exp_content_il_genitivo_diretto_1: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_diretto_1", "exp_content_il_genitivo_diretto_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54327, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54331, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55707, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52311, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50435, 105),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_il_genitivo_diretto_2: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_diretto_2", "exp_content_il_genitivo_diretto_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54437, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54417, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55805, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52413, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50541, 49),
      ))
    }

@delegate:ResourceContentHash(-1_418_846_479)
internal val Res.string.exp_content_il_genitivo_diretto_3: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_diretto_3", "exp_content_il_genitivo_diretto_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54487, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54471, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55859, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52463, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50591, 93),
      ))
    }

@delegate:ResourceContentHash(372_471_445)
internal val Res.string.exp_content_il_genitivo_diretto_4: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_diretto_4", "exp_content_il_genitivo_diretto_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54629, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54593, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 55969, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52581, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50685, 97),
      ))
    }

@delegate:ResourceContentHash(1_807_766_060)
internal val Res.string.exp_content_il_genitivo_diretto_5: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_diretto_5", "exp_content_il_genitivo_diretto_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54747, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54695, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56087, 141),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52683, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50783, 133),
      ))
    }

@delegate:ResourceContentHash(2_097_992_459)
internal val Res.string.exp_content_il_genitivo_diretto_6: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_diretto_6", "exp_content_il_genitivo_diretto_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54881, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54829, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56229, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52813, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50917, 85),
      ))
    }

@delegate:ResourceContentHash(347_060_873)
internal val Res.string.exp_content_il_genitivo_diretto_si_forma_semplicemente_ac: StringResource by
    lazy {
      StringResource("string:exp_content_il_genitivo_diretto_si_forma_semplicemente_ac", "exp_content_il_genitivo_diretto_si_forma_semplicemente_ac", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 54971, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 54899, 185),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56331, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 52895, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51003, 173),
      ))
    }

@delegate:ResourceContentHash(-2_081_407_035)
internal val Res.string.exp_content_il_genitivo_indiretto_1: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_indiretto_1", "exp_content_il_genitivo_indiretto_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55165, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55085, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56509, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53077, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51177, 107),
      ))
    }

@delegate:ResourceContentHash(-2_074_424_074)
internal val Res.string.exp_content_il_genitivo_indiretto_2: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_indiretto_2", "exp_content_il_genitivo_indiretto_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55293, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55185, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56625, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53185, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51285, 79),
      ))
    }

@delegate:ResourceContentHash(-988_208_804)
internal val Res.string.exp_content_il_genitivo_indiretto_3: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_indiretto_3", "exp_content_il_genitivo_indiretto_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55373, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55269, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56705, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53265, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51365, 91),
      ))
    }

@delegate:ResourceContentHash(947_386_386)
internal val Res.string.exp_content_il_genitivo_indiretto_4: StringResource by lazy {
      StringResource("string:exp_content_il_genitivo_indiretto_4", "exp_content_il_genitivo_indiretto_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55473, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55361, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56809, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53353, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51457, 95),
      ))
    }

@delegate:ResourceContentHash(110_406_271)
internal val Res.string.exp_content_il_grande_ritorno_1: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_1", "exp_content_il_grande_ritorno_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56050, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55942, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57358, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53894, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51998, 67),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_il_grande_ritorno_10: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_10", "exp_content_il_grande_ritorno_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55577, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55469, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56913, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53453, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51553, 44),
      ))
    }

@delegate:ResourceContentHash(-446_807_259)
internal val Res.string.exp_content_il_grande_ritorno_11: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_11", "exp_content_il_grande_ritorno_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55622, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55514, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 56958, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53498, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51598, 72),
      ))
    }

@delegate:ResourceContentHash(1_490_337_418)
internal val Res.string.exp_content_il_grande_ritorno_12: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_12", "exp_content_il_grande_ritorno_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55699, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55587, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57031, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53571, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51671, 112),
      ))
    }

@delegate:ResourceContentHash(-2_126_661_329)
internal val Res.string.exp_content_il_grande_ritorno_13: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_13", "exp_content_il_grande_ritorno_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55816, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55704, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57140, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53684, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51784, 116),
      ))
    }

@delegate:ResourceContentHash(-1_172_970_827)
internal val Res.string.exp_content_il_grande_ritorno_14: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_14", "exp_content_il_grande_ritorno_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 55929, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 55837, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57261, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53801, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51901, 96),
      ))
    }

@delegate:ResourceContentHash(-637_995_922)
internal val Res.string.exp_content_il_grande_ritorno_2: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_2", "exp_content_il_grande_ritorno_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56130, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56030, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57434, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 53962, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52066, 55),
      ))
    }

@delegate:ResourceContentHash(-1_189_214_756)
internal val Res.string.exp_content_il_grande_ritorno_3: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_3", "exp_content_il_grande_ritorno_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56186, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56090, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57490, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54018, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52122, 99),
      ))
    }

@delegate:ResourceContentHash(866_360_501)
internal val Res.string.exp_content_il_grande_ritorno_4: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_4", "exp_content_il_grande_ritorno_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56314, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56206, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57610, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54134, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52222, 87),
      ))
    }

@delegate:ResourceContentHash(1_916_845_285)
internal val Res.string.exp_content_il_grande_ritorno_5: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_5", "exp_content_il_grande_ritorno_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56398, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56286, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57694, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54218, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52310, 59),
      ))
    }

@delegate:ResourceContentHash(-1_271_960_630)
internal val Res.string.exp_content_il_grande_ritorno_6: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_6", "exp_content_il_grande_ritorno_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56462, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56350, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57758, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54278, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52370, 71),
      ))
    }

@delegate:ResourceContentHash(1_917_123_390)
internal val Res.string.exp_content_il_grande_ritorno_7: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_7", "exp_content_il_grande_ritorno_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56566, 143),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56438, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57846, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54362, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52442, 135),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_il_grande_ritorno_8: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_8", "exp_content_il_grande_ritorno_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56710, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56562, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 57986, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54486, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52578, 43),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_il_grande_ritorno_9: StringResource by lazy {
      StringResource("string:exp_content_il_grande_ritorno_9", "exp_content_il_grande_ritorno_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56754, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56606, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58030, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54530, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52622, 43),
      ))
    }

@delegate:ResourceContentHash(1_772_869_418)
internal val Res.string.exp_content_il_nome_di_amun_scritto_all_inizio_ma_l_ordine_corretto_alla_fine:
    StringResource by lazy {
      StringResource("string:exp_content_il_nome_di_amun_scritto_all_inizio_ma_l_ordine_corretto_alla_fine", "exp_content_il_nome_di_amun_scritto_all_inizio_ma_l_ordine_corretto_alla_fine", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 56798, 205),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56650, 205),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58074, 205),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54574, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52666, 201),
      ))
    }

@delegate:ResourceContentHash(2_082_209_100)
internal val Res.string.exp_content_il_numero_pu_essere_singolare_plurale_o_duale: StringResource by
    lazy {
      StringResource("string:exp_content_il_numero_pu_essere_singolare_plurale_o_duale", "exp_content_il_numero_pu_essere_singolare_plurale_o_duale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 57004, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56856, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58280, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54772, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52868, 125),
      ))
    }

@delegate:ResourceContentHash(-1_522_218_222)
internal val Res.string.exp_content_il_plurale_si_fa_aggiungendo_il_segno_u_prima: StringResource by
    lazy {
      StringResource("string:exp_content_il_plurale_si_fa_aggiungendo_il_segno_u_prima", "exp_content_il_plurale_si_fa_aggiungendo_il_segno_u_prima", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 57134, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 56982, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58410, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 54906, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52994, 153),
      ))
    }

@delegate:ResourceContentHash(-1_737_659_017)
internal val Res.string.exp_content_il_plurale_si_forma_tipicamente_aggiungendo_l: StringResource by
    lazy {
      StringResource("string:exp_content_il_plurale_si_forma_tipicamente_aggiungendo_l", "exp_content_il_plurale_si_forma_tipicamente_aggiungendo_l", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 57320, 257),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 57144, 237),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58568, 237),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 55064, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53148, 225),
      ))
    }

@delegate:ResourceContentHash(1_610_774_657)
internal val Res.string.exp_content_il_primo_nome_nel_cartiglio_il_nome_di_incoronazione:
    StringResource by lazy {
      StringResource("string:exp_content_il_primo_nome_nel_cartiglio_il_nome_di_incoronazione", "exp_content_il_primo_nome_nel_cartiglio_il_nome_di_incoronazione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 57578, 156),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 57382, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58806, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 55298, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53374, 152),
      ))
    }

@delegate:ResourceContentHash(663_910_588)
internal val Res.string.exp_content_il_primo_segno_si_legge_nsut_e_significa_re_d: StringResource by
    lazy {
      StringResource("string:exp_content_il_primo_segno_si_legge_nsut_e_significa_re_d", "exp_content_il_primo_segno_si_legge_nsut_e_significa_re_d", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 57735, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 57547, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 58971, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 55455, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53527, 145),
      ))
    }

@delegate:ResourceContentHash(-1_890_256_356)
internal val Res.string.exp_content_il_segno_di_una_papera_ha_le_stesse_dimension: StringResource by
    lazy {
      StringResource("string:exp_content_il_segno_di_una_papera_ha_le_stesse_dimension", "exp_content_il_segno_di_una_papera_ha_le_stesse_dimension", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 57901, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 57701, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59125, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 55605, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53673, 133),
      ))
    }

@delegate:ResourceContentHash(-441_181_925)
internal val Res.string.exp_content_il_segreto_della_piramide_1: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_1", "exp_content_il_segreto_della_piramide_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58616, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58424, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59848, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56272, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54352, 95),
      ))
    }

@delegate:ResourceContentHash(-173_649_791)
internal val Res.string.exp_content_il_segreto_della_piramide_10: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_10", "exp_content_il_segreto_della_piramide_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58067, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 57871, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59279, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 55767, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53807, 84),
      ))
    }

@delegate:ResourceContentHash(704_719_570)
internal val Res.string.exp_content_il_segreto_della_piramide_11: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_11", "exp_content_il_segreto_della_piramide_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58164, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 57972, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59384, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 55852, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53892, 80),
      ))
    }

@delegate:ResourceContentHash(-2_129_094_952)
internal val Res.string.exp_content_il_segreto_della_piramide_12: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_12", "exp_content_il_segreto_della_piramide_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58245, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58053, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59465, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 55929, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53973, 108),
      ))
    }

@delegate:ResourceContentHash(-970_018_665)
internal val Res.string.exp_content_il_segreto_della_piramide_13: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_13", "exp_content_il_segreto_della_piramide_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58354, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58166, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59570, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56034, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54082, 132),
      ))
    }

@delegate:ResourceContentHash(-1_387_329_793)
internal val Res.string.exp_content_il_segreto_della_piramide_14: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_14", "exp_content_il_segreto_della_piramide_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58495, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58299, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59715, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56159, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54215, 136),
      ))
    }

@delegate:ResourceContentHash(955_698_329)
internal val Res.string.exp_content_il_segreto_della_piramide_2: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_2", "exp_content_il_segreto_della_piramide_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58704, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58532, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 59948, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56372, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54448, 103),
      ))
    }

@delegate:ResourceContentHash(1_408_512_220)
internal val Res.string.exp_content_il_segreto_della_piramide_3: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_3", "exp_content_il_segreto_della_piramide_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58820, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58660, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60072, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56492, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54552, 95),
      ))
    }

@delegate:ResourceContentHash(1_770_239_480)
internal val Res.string.exp_content_il_segreto_della_piramide_4: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_4", "exp_content_il_segreto_della_piramide_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 58920, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58768, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60192, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56592, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54648, 99),
      ))
    }

@delegate:ResourceContentHash(-1_591_915_442)
internal val Res.string.exp_content_il_segreto_della_piramide_5: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_5", "exp_content_il_segreto_della_piramide_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59028, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58880, 151),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60324, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56696, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54748, 147),
      ))
    }

@delegate:ResourceContentHash(1_823_937_989)
internal val Res.string.exp_content_il_segreto_della_piramide_6: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_6", "exp_content_il_segreto_della_piramide_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59180, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59032, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60476, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56840, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54896, 99),
      ))
    }

@delegate:ResourceContentHash(-551_438_946)
internal val Res.string.exp_content_il_segreto_della_piramide_7: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_7", "exp_content_il_segreto_della_piramide_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59300, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59144, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60592, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 56948, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54996, 51),
      ))
    }

@delegate:ResourceContentHash(-1_610_080_780)
internal val Res.string.exp_content_il_segreto_della_piramide_8: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_8", "exp_content_il_segreto_della_piramide_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59352, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59196, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60644, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57000, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55048, 75),
      ))
    }

@delegate:ResourceContentHash(1_681_726_675)
internal val Res.string.exp_content_il_segreto_della_piramide_9: StringResource by lazy {
      StringResource("string:exp_content_il_segreto_della_piramide_9", "exp_content_il_segreto_della_piramide_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59432, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59288, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60720, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57080, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55124, 127),
      ))
    }

@delegate:ResourceContentHash(-939_792_769)
internal val Res.string.exp_content_il_tema_verbale_sdm_f_1: StringResource by lazy {
      StringResource("string:exp_content_il_tema_verbale_sdm_f_1", "exp_content_il_tema_verbale_sdm_f_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59568, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59424, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 60864, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57212, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55252, 123),
      ))
    }

@delegate:ResourceContentHash(1_597_378_780)
internal val Res.string.exp_content_il_tema_verbale_sdm_f_2: StringResource by lazy {
      StringResource("string:exp_content_il_tema_verbale_sdm_f_2", "exp_content_il_tema_verbale_sdm_f_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59692, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59568, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61004, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57352, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55376, 139),
      ))
    }

@delegate:ResourceContentHash(1_905_254_920)
internal val Res.string.exp_content_il_tema_verbale_sdm_f_3: StringResource by lazy {
      StringResource("string:exp_content_il_tema_verbale_sdm_f_3", "exp_content_il_tema_verbale_sdm_f_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59844, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59708, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61148, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57484, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55516, 107),
      ))
    }

@delegate:ResourceContentHash(1_983_161_141)
internal val Res.string.exp_content_il_tema_verbale_sdm_f_4: StringResource by lazy {
      StringResource("string:exp_content_il_tema_verbale_sdm_f_4", "exp_content_il_tema_verbale_sdm_f_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 59948, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59820, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61288, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57596, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55624, 83),
      ))
    }

@delegate:ResourceContentHash(1_177_067_818)
internal val Res.string.exp_content_il_verbo_ma_i_1: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_1", "exp_content_il_verbo_ma_i_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60582, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60438, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61950, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58182, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56226, 91),
      ))
    }

@delegate:ResourceContentHash(-1_683_066_536)
internal val Res.string.exp_content_il_verbo_ma_i_10: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_10", "exp_content_il_verbo_ma_i_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60032, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 59900, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61380, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57680, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55708, 116),
      ))
    }

@delegate:ResourceContentHash(-1_635_646_348)
internal val Res.string.exp_content_il_verbo_ma_i_11: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_11", "exp_content_il_verbo_ma_i_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60133, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60009, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61477, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57769, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55825, 92),
      ))
    }

@delegate:ResourceContentHash(-1_052_707_232)
internal val Res.string.exp_content_il_verbo_ma_i_12: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_12", "exp_content_il_verbo_ma_i_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60238, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60110, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61586, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57862, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55918, 64),
      ))
    }

@delegate:ResourceContentHash(1_891_527_517)
internal val Res.string.exp_content_il_verbo_ma_i_13: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_13", "exp_content_il_verbo_ma_i_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60315, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60175, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61651, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 57927, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55983, 76),
      ))
    }

@delegate:ResourceContentHash(1_235_162_753)
internal val Res.string.exp_content_il_verbo_ma_i_14: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_14", "exp_content_il_verbo_ma_i_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60404, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60260, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61752, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58012, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56060, 84),
      ))
    }

@delegate:ResourceContentHash(-556_614_404)
internal val Res.string.exp_content_il_verbo_ma_i_15: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_15", "exp_content_il_verbo_ma_i_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60493, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60353, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 61837, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58089, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56145, 80),
      ))
    }

@delegate:ResourceContentHash(1_905_656_463)
internal val Res.string.exp_content_il_verbo_ma_i_2: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_2", "exp_content_il_verbo_ma_i_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60686, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60534, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62058, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58278, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56318, 67),
      ))
    }

@delegate:ResourceContentHash(-551_519_269)
internal val Res.string.exp_content_il_verbo_ma_i_3: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_3", "exp_content_il_verbo_ma_i_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60754, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60598, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62130, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58346, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56386, 79),
      ))
    }

@delegate:ResourceContentHash(-446_095_651)
internal val Res.string.exp_content_il_verbo_ma_i_4: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_4", "exp_content_il_verbo_ma_i_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60838, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60674, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62210, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58426, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56466, 95),
      ))
    }

@delegate:ResourceContentHash(572_393_960)
internal val Res.string.exp_content_il_verbo_ma_i_5: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_5", "exp_content_il_verbo_ma_i_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 60938, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60786, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62318, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58514, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56562, 79),
      ))
    }

@delegate:ResourceContentHash(2_093_821_351)
internal val Res.string.exp_content_il_verbo_ma_i_6: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_6", "exp_content_il_verbo_ma_i_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61030, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60874, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62406, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58602, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56642, 75),
      ))
    }

@delegate:ResourceContentHash(2_033_871_728)
internal val Res.string.exp_content_il_verbo_ma_i_7: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_7", "exp_content_il_verbo_ma_i_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61106, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 60942, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62502, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58670, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56718, 83),
      ))
    }

@delegate:ResourceContentHash(1_851_669_071)
internal val Res.string.exp_content_il_verbo_ma_i_8: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_8", "exp_content_il_verbo_ma_i_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61182, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61010, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62578, 147),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58746, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56802, 119),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_frasi_con_soggetto_1", Res.string.exp_content_frasi_con_soggetto_1)
  map.put("exp_content_frasi_con_soggetto_2", Res.string.exp_content_frasi_con_soggetto_2)
  map.put("exp_content_frasi_con_soggetto_3", Res.string.exp_content_frasi_con_soggetto_3)
  map.put("exp_content_frasi_con_soggetto_4", Res.string.exp_content_frasi_con_soggetto_4)
  map.put("exp_content_frasi_con_soggetto_5", Res.string.exp_content_frasi_con_soggetto_5)
  map.put("exp_content_frequentemente_venivano_ripetuti_i_simboli_an", Res.string.exp_content_frequentemente_venivano_ripetuti_i_simboli_an)
  map.put("exp_content_genitivo_indiretto_esempio_1", Res.string.exp_content_genitivo_indiretto_esempio_1)
  map.put("exp_content_genitivo_indiretto_esempio_2", Res.string.exp_content_genitivo_indiretto_esempio_2)
  map.put("exp_content_gli_scribi_si_sentivano_molto_liberi_di_piega", Res.string.exp_content_gli_scribi_si_sentivano_molto_liberi_di_piega)
  map.put("exp_content_hiero_verbs_2_nilo", Res.string.exp_content_hiero_verbs_2_nilo)
  map.put("exp_content_hiero_verbs_3_alyn", Res.string.exp_content_hiero_verbs_3_alyn)
  map.put("exp_content_hiero_verbs_3_zeta", Res.string.exp_content_hiero_verbs_3_zeta)
  map.put("exp_content_i_cartigli_erano_riservati_alle_divinita_inclusi_i_faraoni", Res.string.exp_content_i_cartigli_erano_riservati_alle_divinita_inclusi_i_faraoni)
  map.put("exp_content_i_complementi_fonetici_sono_segni_monolitteri", Res.string.exp_content_i_complementi_fonetici_sono_segni_monolitteri)
  map.put("exp_content_i_disegni_geroglifici_sono_calibrati_ovvero_n", Res.string.exp_content_i_disegni_geroglifici_sono_calibrati_ovvero_n)
  map.put("exp_content_i_due_fratelli_snuy", Res.string.exp_content_i_due_fratelli_snuy)
  map.put("exp_content_i_fonogrammi_rappresentano_suoni_n_npossono_e", Res.string.exp_content_i_fonogrammi_rappresentano_suoni_n_npossono_e)
  map.put("exp_content_i_geroglifici_rappresentano_solo_consonanti_e", Res.string.exp_content_i_geroglifici_rappresentano_solo_consonanti_e)
  map.put("exp_content_i_simboli_determinativi_servono_a_chiarire_il", Res.string.exp_content_i_simboli_determinativi_servono_a_chiarire_il)
  map.put("exp_content_i_verbi_pi_comuni_della_lingua_egizia", Res.string.exp_content_i_verbi_pi_comuni_della_lingua_egizia)
  map.put("exp_content_il_dimostrativo_pn_1", Res.string.exp_content_il_dimostrativo_pn_1)
  map.put("exp_content_il_dimostrativo_pn_10", Res.string.exp_content_il_dimostrativo_pn_10)
  map.put("exp_content_il_dimostrativo_pn_11", Res.string.exp_content_il_dimostrativo_pn_11)
  map.put("exp_content_il_dimostrativo_pn_12", Res.string.exp_content_il_dimostrativo_pn_12)
  map.put("exp_content_il_dimostrativo_pn_13", Res.string.exp_content_il_dimostrativo_pn_13)
  map.put("exp_content_il_dimostrativo_pn_14", Res.string.exp_content_il_dimostrativo_pn_14)
  map.put("exp_content_il_dimostrativo_pn_15", Res.string.exp_content_il_dimostrativo_pn_15)
  map.put("exp_content_il_dimostrativo_pn_2", Res.string.exp_content_il_dimostrativo_pn_2)
  map.put("exp_content_il_dimostrativo_pn_3", Res.string.exp_content_il_dimostrativo_pn_3)
  map.put("exp_content_il_dimostrativo_pn_4", Res.string.exp_content_il_dimostrativo_pn_4)
  map.put("exp_content_il_dimostrativo_pn_5", Res.string.exp_content_il_dimostrativo_pn_5)
  map.put("exp_content_il_dimostrativo_pn_6", Res.string.exp_content_il_dimostrativo_pn_6)
  map.put("exp_content_il_dimostrativo_pn_7", Res.string.exp_content_il_dimostrativo_pn_7)
  map.put("exp_content_il_dimostrativo_pn_8", Res.string.exp_content_il_dimostrativo_pn_8)
  map.put("exp_content_il_dimostrativo_pn_9", Res.string.exp_content_il_dimostrativo_pn_9)
  map.put("exp_content_il_genere_pu_essere_maschile_o_femminile", Res.string.exp_content_il_genere_pu_essere_maschile_o_femminile)
  map.put("exp_content_il_genitivo_diretto_1", Res.string.exp_content_il_genitivo_diretto_1)
  map.put("exp_content_il_genitivo_diretto_2", Res.string.exp_content_il_genitivo_diretto_2)
  map.put("exp_content_il_genitivo_diretto_3", Res.string.exp_content_il_genitivo_diretto_3)
  map.put("exp_content_il_genitivo_diretto_4", Res.string.exp_content_il_genitivo_diretto_4)
  map.put("exp_content_il_genitivo_diretto_5", Res.string.exp_content_il_genitivo_diretto_5)
  map.put("exp_content_il_genitivo_diretto_6", Res.string.exp_content_il_genitivo_diretto_6)
  map.put("exp_content_il_genitivo_diretto_si_forma_semplicemente_ac", Res.string.exp_content_il_genitivo_diretto_si_forma_semplicemente_ac)
  map.put("exp_content_il_genitivo_indiretto_1", Res.string.exp_content_il_genitivo_indiretto_1)
  map.put("exp_content_il_genitivo_indiretto_2", Res.string.exp_content_il_genitivo_indiretto_2)
  map.put("exp_content_il_genitivo_indiretto_3", Res.string.exp_content_il_genitivo_indiretto_3)
  map.put("exp_content_il_genitivo_indiretto_4", Res.string.exp_content_il_genitivo_indiretto_4)
  map.put("exp_content_il_grande_ritorno_1", Res.string.exp_content_il_grande_ritorno_1)
  map.put("exp_content_il_grande_ritorno_10", Res.string.exp_content_il_grande_ritorno_10)
  map.put("exp_content_il_grande_ritorno_11", Res.string.exp_content_il_grande_ritorno_11)
  map.put("exp_content_il_grande_ritorno_12", Res.string.exp_content_il_grande_ritorno_12)
  map.put("exp_content_il_grande_ritorno_13", Res.string.exp_content_il_grande_ritorno_13)
  map.put("exp_content_il_grande_ritorno_14", Res.string.exp_content_il_grande_ritorno_14)
  map.put("exp_content_il_grande_ritorno_2", Res.string.exp_content_il_grande_ritorno_2)
  map.put("exp_content_il_grande_ritorno_3", Res.string.exp_content_il_grande_ritorno_3)
  map.put("exp_content_il_grande_ritorno_4", Res.string.exp_content_il_grande_ritorno_4)
  map.put("exp_content_il_grande_ritorno_5", Res.string.exp_content_il_grande_ritorno_5)
  map.put("exp_content_il_grande_ritorno_6", Res.string.exp_content_il_grande_ritorno_6)
  map.put("exp_content_il_grande_ritorno_7", Res.string.exp_content_il_grande_ritorno_7)
  map.put("exp_content_il_grande_ritorno_8", Res.string.exp_content_il_grande_ritorno_8)
  map.put("exp_content_il_grande_ritorno_9", Res.string.exp_content_il_grande_ritorno_9)
  map.put("exp_content_il_nome_di_amun_scritto_all_inizio_ma_l_ordine_corretto_alla_fine", Res.string.exp_content_il_nome_di_amun_scritto_all_inizio_ma_l_ordine_corretto_alla_fine)
  map.put("exp_content_il_numero_pu_essere_singolare_plurale_o_duale", Res.string.exp_content_il_numero_pu_essere_singolare_plurale_o_duale)
  map.put("exp_content_il_plurale_si_fa_aggiungendo_il_segno_u_prima", Res.string.exp_content_il_plurale_si_fa_aggiungendo_il_segno_u_prima)
  map.put("exp_content_il_plurale_si_forma_tipicamente_aggiungendo_l", Res.string.exp_content_il_plurale_si_forma_tipicamente_aggiungendo_l)
  map.put("exp_content_il_primo_nome_nel_cartiglio_il_nome_di_incoronazione", Res.string.exp_content_il_primo_nome_nel_cartiglio_il_nome_di_incoronazione)
  map.put("exp_content_il_primo_segno_si_legge_nsut_e_significa_re_d", Res.string.exp_content_il_primo_segno_si_legge_nsut_e_significa_re_d)
  map.put("exp_content_il_segno_di_una_papera_ha_le_stesse_dimension", Res.string.exp_content_il_segno_di_una_papera_ha_le_stesse_dimension)
  map.put("exp_content_il_segreto_della_piramide_1", Res.string.exp_content_il_segreto_della_piramide_1)
  map.put("exp_content_il_segreto_della_piramide_10", Res.string.exp_content_il_segreto_della_piramide_10)
  map.put("exp_content_il_segreto_della_piramide_11", Res.string.exp_content_il_segreto_della_piramide_11)
  map.put("exp_content_il_segreto_della_piramide_12", Res.string.exp_content_il_segreto_della_piramide_12)
  map.put("exp_content_il_segreto_della_piramide_13", Res.string.exp_content_il_segreto_della_piramide_13)
  map.put("exp_content_il_segreto_della_piramide_14", Res.string.exp_content_il_segreto_della_piramide_14)
  map.put("exp_content_il_segreto_della_piramide_2", Res.string.exp_content_il_segreto_della_piramide_2)
  map.put("exp_content_il_segreto_della_piramide_3", Res.string.exp_content_il_segreto_della_piramide_3)
  map.put("exp_content_il_segreto_della_piramide_4", Res.string.exp_content_il_segreto_della_piramide_4)
  map.put("exp_content_il_segreto_della_piramide_5", Res.string.exp_content_il_segreto_della_piramide_5)
  map.put("exp_content_il_segreto_della_piramide_6", Res.string.exp_content_il_segreto_della_piramide_6)
  map.put("exp_content_il_segreto_della_piramide_7", Res.string.exp_content_il_segreto_della_piramide_7)
  map.put("exp_content_il_segreto_della_piramide_8", Res.string.exp_content_il_segreto_della_piramide_8)
  map.put("exp_content_il_segreto_della_piramide_9", Res.string.exp_content_il_segreto_della_piramide_9)
  map.put("exp_content_il_tema_verbale_sdm_f_1", Res.string.exp_content_il_tema_verbale_sdm_f_1)
  map.put("exp_content_il_tema_verbale_sdm_f_2", Res.string.exp_content_il_tema_verbale_sdm_f_2)
  map.put("exp_content_il_tema_verbale_sdm_f_3", Res.string.exp_content_il_tema_verbale_sdm_f_3)
  map.put("exp_content_il_tema_verbale_sdm_f_4", Res.string.exp_content_il_tema_verbale_sdm_f_4)
  map.put("exp_content_il_verbo_ma_i_1", Res.string.exp_content_il_verbo_ma_i_1)
  map.put("exp_content_il_verbo_ma_i_10", Res.string.exp_content_il_verbo_ma_i_10)
  map.put("exp_content_il_verbo_ma_i_11", Res.string.exp_content_il_verbo_ma_i_11)
  map.put("exp_content_il_verbo_ma_i_12", Res.string.exp_content_il_verbo_ma_i_12)
  map.put("exp_content_il_verbo_ma_i_13", Res.string.exp_content_il_verbo_ma_i_13)
  map.put("exp_content_il_verbo_ma_i_14", Res.string.exp_content_il_verbo_ma_i_14)
  map.put("exp_content_il_verbo_ma_i_15", Res.string.exp_content_il_verbo_ma_i_15)
  map.put("exp_content_il_verbo_ma_i_2", Res.string.exp_content_il_verbo_ma_i_2)
  map.put("exp_content_il_verbo_ma_i_3", Res.string.exp_content_il_verbo_ma_i_3)
  map.put("exp_content_il_verbo_ma_i_4", Res.string.exp_content_il_verbo_ma_i_4)
  map.put("exp_content_il_verbo_ma_i_5", Res.string.exp_content_il_verbo_ma_i_5)
  map.put("exp_content_il_verbo_ma_i_6", Res.string.exp_content_il_verbo_ma_i_6)
  map.put("exp_content_il_verbo_ma_i_7", Res.string.exp_content_il_verbo_ma_i_7)
  map.put("exp_content_il_verbo_ma_i_8", Res.string.exp_content_il_verbo_ma_i_8)
}
